export class RequestModel{
    userId: string;
    payload:string;
    idVariable: number;
    extraVariable: string;
    reqObject: any;
    reqList: Array<any>;
    reqArray: String[];
}